import { render, staticRenderFns } from "./HRMAddEmergencyContactModal.vue?vue&type=template&id=9e7842f8&"
import script from "./HRMAddEmergencyContactModal.vue?vue&type=script&lang=js&"
export * from "./HRMAddEmergencyContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports